export const dpomOrderColumnsName = {
    documentDate: 'document_date',
    purchaseOrderNumber: 'po_umber',
    poLineItemNumber: 'po_line_item_number',
    scheduleLineItemNumber: 'schedule_line_item_number',
    categoryCode: 'category_code',
    categoryDesc: 'category_desc',
    vendorCode: 'vendor_code',
    gccFocusCode: 'gcc_focus_code',
    gccFocusDesc: 'gcc_focus_desc',
    genderAgeCode: 'gender_age_code',
    genderAgeDesc: 'gender_age_desc',
    styleNumber: 'style_number',
    productCode: 'product_code',
    colorDesc: 'color_desc',
    destinationCountryCode: 'destination_country_code',
    destinationCountry: 'destination_country',
    plant: 'plant',
    plantName: 'plant_name',
    tradingCoPoNumber: 'trading_co_po_no',
    UPC: 'upc',
    directShipSONumber: 'direct_ship_so_no',
    directShipSOItemNumber: 'direct_ship_so_item_no',
    customerPO: 'customer_po',
    shipToCustomerNumber: 'ship_to_customer_no',
    shipToCustomerName: 'ship_to_customer_name',
    planningSeasonCode: 'planning_season_code',
    planningSeasonYear: 'planning_season_year',
    docTypeCode: 'doc_type_code',
    docTypeDesc: 'doc_type_desc',
    MRGAC: 'mrgac',
    OGAC: 'ogac',
    GAC: 'gac',
    originReceiptDate: 'origin_receipt_date',
    factoryDeliveryActDate: 'factory_delivery_date',
    GACReasonCode: 'gac_reason_code',
    GACReasonDesc: 'gac_reason_desc',
    shippingType: 'shipping_type',
    planningPriorityCode: 'planning_priority_code',
    planningPriorityDesc: 'planning_priority_desc',
    launchCode: 'launch_code',
    DPOMLineItemStatus: 'dpom_line_item_status',
    modeOfTransportationCode: 'mode_of_transport_code',
    inCoTerms: 'inco_terms',
    inventorySegmentCode: 'inventory_segment_code',
    purchaseGroupCode: 'purchase_group_code',
    purchaseGroupName: 'purchase_group_name',
    totalItemQty: 'total_item_qty',
    originReceiptQty: 'origin_receipt_qty',
    VASSize: 'vas_size',
    itemVasText: 'item_vas_text',
    itemText: 'item_text',
    grossPriceFOB: 'gross_price_fob',
    FOBCurrencyCode: 'fob_currency_code',
    netIncludingDisc: 'net_inc_disc',
    netIncludingDiscCurrencyCode: 'net_inc_disc_currency_code',
    trCoNetIncludingDisc: 'trading_net_inc_disc',
    trCoNetIncludingDiscCurrencyCode: 'trading_net_currency_code',
    sizeQuantity: 'size_qty',
    sizeDescription: 'size_description',

}